import { all_routes } from "../../../feature-module/router/all_routes";
// import store from "../../../redux/store";

const routes = all_routes;

const sideBarData = (user_role: string, user: any) => {
  // Common Submenu Items
  const getCommonSubmenuItems = () => {
    switch (user_role) {
      case "teacher":
        return [{ label: "Teacher Dashboard", link: routes.teacherDashboard }];
      case "admin":
        return [{ label: "Admin Dashboard", link: routes.adminDashboard }];
      case "superadmin":
        return [
          { label: "Super Admin Dashboard", link: routes.superAdminDashboard },
        ];
      case "parent":
        return [{ label: "Parent Dashboard", link: routes.parentDashboard }];
      default:
        return [{ label: "Student Dashboard", link: routes.studentDashboard }];
    }
  };

  return [
    {
      label: "MAIN",
      submenuOpen: true,
      showSubRoute: false,
      submenuHdr: "Main",
      submenuItems: [
        {
          label: `${user_role} Dashboard`,
          icon: "ti ti-layout-dashboard",
          submenu: false,
          showSubRoute: false,
          link: getCommonSubmenuItems()[0]?.link,
          submenuItems: getCommonSubmenuItems(),
        },
      ],
    },
    ...(user_role === "parent"
      ? [
          {
            label: "Parent",
            submenuOpen: true,
            submenuHdr: "Parent",
            submenuItems: [
              {
                label: "Children",
                icon: "ti ti-id-badge",
                link: routes.parentChildren,
              },
              {
                label: "Billings",
                icon: "ti ti-table",
                link: routes.familyBillProcess,
              },
            ],
          },
        ]
      : []),
    ...(user_role === "admin" || user_role === 'branchadmin'
      ? [
          {
            label: "Peoples",
            submenuOpen: true,
            submenuHdr: "Peoples",
            submenuItems: [
              {
                label: "Students",
                icon: "ti ti-school",
                submenu: true,
                submenuItems: [
                  // { label: "Add Returning Student", link: routes.addStudent },
                  { label: "Students List", link: routes.studentList },
                ],
              },
              {
                label: "Application",
                icon: "ti ti-school",
                submenu: true,
                submenuItems: [
                  { label: "Application List", link: routes.applicationtList },
                  {
                    label: "Entrance Exams Score",
                    link: routes.entranceExamsScore,
                  },
                ],
              },
              {
                label: "Parents",
                icon: "ti ti-user-bolt",
                submenu: true,
                submenuItems: [
                  { label: "Parent List", link: routes.parentList },
                ],
              },
              {
                label: "Teachers",
                icon: "ti ti-users",
                submenu: true,
                submenuItems: [
                  { label: "Teacher List", link: routes.teacherList },
                ],
              },
              {
                label: "Attendance",
                // link: routes.classAttendance,
                icon: "ti ti-users",
                submenu: true,
                submenuItems: [
                  { label: "Student Attendance", link: routes.classAttendance },
                  // { label: "Student Attendance", link: routes.studentAttendance },
                  // { label: "Admin Attendance", link: routes.adminAttendance },
                  // { label: "Staff Attendance", link: routes.staffAttendance },
                  // { label: "Staffs Attendance", link: routes.staffsAttendance },
                  // { label: "Teacher Attendance", link: routes.teacherAttendance },
                ],
              },
            ],
          },
        ]
      : []),
    ...(user_role === "superadmin"
      ? [
          {
            label: "School Setup",
            icon: "ti ti-hexagonal-prism-plus",
            submenu: true,
            submenuItems: [
              {
                label: "Create School",
                link: routes.schoolSetup,
                showSubRoute: false,
              },
              {
                label: "School List",
                link: routes.schoolList,
                showSubRoute: false,
              },
            ],
          },
        ]
      : []),
    ...(user_role === "admin" || user_role === 'branchadmin'
      ? [
          {
            label: "Finance & Account",
            submenuOpen: true,
            submenuHdr: "Finance & Account",
            submenuItems: [
              {
                label: "Express Finance",
                icon: "ti ti-report-money",
                submenu: true,
                submenuItems: [
                  { label: "Generic Fees Setup", link: routes.feesGroup },
                  {
                    label: "Fees Setup",
                    link: routes.feesSetup,
                    icon: "ti ti-bank",
                    submenu: false,
                  },
                 
                  // { label: "Fees Type", link: routes.feesType },
                  // { label: "Fees Master", link: routes.feesMaster },
                  // { label: "Fees Assign", link: routes.feesAssign },
                  {
                    label: "Fees & Billing",
                    link: routes.collectFees,
                    icon: "ti ti-usd",
                  },
                  {
                    label: "Payments & Receipts",
                    link: routes.feesReceiptProcess,
                    icon: "ti ti-paper",
                  },
                  {
                    label: "Income and Expenses Setting",
                    link: routes.incomeExpensesSettings,
                    icon: "ti ti-bank",
                    submenu: false,
                  },
                  {
                    label: "Income & Expeses Reports",
                    icon: "ti ti-report-money",
                    submenu: true,
                    showSubRoute: false,
                    submenuItems: [
                      {
                        label: "Income Reports",
                        link: routes.incomeReport,
                      },
                      {
                        label: "Expeses reports",
                        link: routes.expensesReport,
                      },
                      {
                        label: "Profit and Losses Reports",
                        link: routes.profitLossReport,
                      },
                    ],
                  },
                ],
              },
              {
                label: "Account Chart",
                icon: "ti ti-report-money",
                submenu: true,
                submenuItems: [
                  { label: "Generic Fees Setup", link: routes.accountChart },
                ],
              },
            ],
          },
        ]
      : []),
    ...(["admin", "teacher", "student",'branchadmin'].includes(user_role)
      ? [
          {
            label: "Academic",
            submenuOpen: true,
            submenuHdr: "Academic",
            submenuItems:
              user_role === "admin" || user_role === 'branchadmin'
                ? [
                    // {
                    //   label: "Classes",
                    //   icon: "ti ti-school-bell",
                    //   submenu: true,
                    //   submenuItems: [
                    //     { label: "All Classes", link: routes.classes },
                    //     { label: "Attendance", link: routes.classAttendance },
                    //   ],
                    // },
                   
                    {
                      label: "Time Table",
                      link: routes.classTimetable,
                      icon: "ti ti-table",
                      submenu: false,
                    },
                    {
                      label: "Examinations",
                      icon: "ti ti-hexagonal-prism-plus",
                      submenu: true,
                      submenuItems: [
                        { label: "Exam Schedule", link: routes.examSchedule },
                        {
                          label: "Exam Attendance",
                          link: routes.examAttendance,
                        },
                        { label: "Grade Student", link: routes.examResult },
                        { label: "Grade Class", link: routes.resultClass },
                        // { label: "Exam Results", link: routes.generalResults },
                        {
                          label: "Generate Class Report",
                          link: routes.gradeReport,
                        },
                        // { label: "Generate Student RC", link: routes.gradeReport }
                      ],
                    },
                    {
                      label: "School Setup",
                      icon: "ti ti-hexagonal-prism-plus",
                      submenu: true,
                      submenuItems: [
                        { label: "School Calendar", link: routes.calendar},
                        { label: "Branches", link: routes.branches},
                        { label: "Automate TimeTable", link: routes.automateTimeTable},
                        {
                          label: "Subjects Setup",
                          link: routes.Subjects,
                          icon: "ti ti-book",
                          submenu: false,
                        },
                        {
                          label: "Character Traits Setup",
                          link: routes.characterSubjects,
                          icon: "ti ti-book",
                          submenu: false,
                        },
                        { label: "School Calendar", link: routes.calendar },
                        { label: "Time Duration", link: routes.classTaming },
                        { label: "Exam Calendar", link: routes.exam },
                        { label: "Grade Setup", link: routes.grade },
                        { label: "Classes Setup", link: routes.classes },
                        {
                          label: "Section Form",
                          link: routes.sectionSetup,
                        },
                        {
                          label: "Academic Calendar",
                          link: routes.academicYear,
                        },
                        
                      ],
                    },
                  ]
                : user_role === "student"
                ? [
                    {
                      label: `${user?.current_class} Attendances`,
                      icon: "ti ti-id-badge",
                      link: routes.studentAttendance,
                    },
                    {
                      label: "Time Table",
                      icon: "ti ti-table",
                      link: routes.studentTimetable,
                    },
                    {
                      label: "Lessons",
                      icon: "ti ti-book",
                      link: routes.Lessons,
                    },
                    {
                      label: "Assignments",
                      icon: "ti ti-license",
                      link: routes.studentAssignments,
                    },
                    {
                      label: "My Result",
                      icon: "ti ti-receipt",
                      link: routes.studentResult,
                    },
                  ]
                : user_role === "teacher"
                ? [
                    {
                      label: "Staff Attendance",
                      icon: "ti ti-id-badge",
                      link: routes.teacherAttendance,
                    },
                    {
                      label: "Class Attendance",
                      icon: "ti ti-id-badge",
                      link: routes.classAttendance,
                    },
                    {
                      label: "Time Table",
                      icon: "ti ti-table",
                      link: routes.classTimetable,
                    },
                    {
                      label: "Lessons",
                      icon: "ti ti-book",
                      link: routes.TearcherLessons,
                    },
                    {
                      label: "Assignments",
                      icon: "ti ti-license",
                      link: routes.classHomeWork,
                    },
                    {
                      label: "Syllabus",
                      icon: "ti ti-dashboard",
                      link: routes.classSyllabus,
                    },
                    {
                      label: "Task/Todo",
                      icon: "ti ti-clock",
                      link: routes.todo,
                    },
                    {
                      label: "Examinations",
                      icon: "ti ti-hexagonal-prism-plus",
                      submenu: true,
                      submenuItems: [
                        // { label: "Exam Calendar", link: routes.exam },
                        // { label: "Exam Schedule", link: routes.examSchedule },
                        {
                          label: "Exam Attendance",
                          link: routes.examAttendance,
                        },
                        // { label: "Grade Setup", link: routes.grade },
                        { label: "Grade Class", link: routes.resultClass },
                        { label: "Class Results", link: routes.resultClass },

                        // { label: "Grade Student", link: routes.examResult },
                        // { label: "Exam Results", link: routes.generalResults },
                        // { label: "Generate Student RC", link: routes.gradeReport },

                        {
                          label: "Generate Class Report",
                          link: routes.gradeReport,
                        },
                      ],
                    },
                  ]
                : [],
          },
        ]
      : []),
  ];
};

export default sideBarData;
